import React, { useContext } from "react";
import { useMessageSource } from "react-message-source";
import { TableFilterProps } from "./types";
import FilterByFamily from "./filter-by-family";
import FilterByProduct from "./filter-by-product";
import { DropdownMenuItemProps } from "../../../../../ui/widgets/dropdown/types";
import SectionHalfItemContainer from "../../../../../ui/layout/page/forms-container/section-half-item-container";
import GridItem from "../../../../../ui/layout/page/grid-item";
import { ProductContext } from "../../../../../context/product-context/productContext";
import { ProductFamily } from "../../../../../context/product-context/product-family";
import { ProductRefType } from "../../../../../context/product-context/types";
import DashboardHelper from "../../../helper";
import { SelectChangeEvent } from "@mui/material";

export default function TableFilter({
  cardholderApplications,
  filterByFamily,
  setFilterByFamily,
  filterByProduct,
  setFilterByProduct,
}: TableFilterProps): React.JSX.Element {
  const { getMessage } = useMessageSource();
  const { findFamilyFromAll } = useContext(ProductContext);

  const defaultFilterValue: DropdownMenuItemProps = {
    value: "any",
    children: getMessage("Dashboard.cardholderApplication.filter-all"),
  };

  const handleOnFilterFamilySelect = (
    e: SelectChangeEvent<string | number | string[]>,
  ): void => {
    setFilterByFamily(
      DashboardHelper.getFamilyWithCompletedProducts(
        findFamilyFromAll(e.target.value as ProductFamily["name"]),
        cardholderApplications,
      ),
    );
    setFilterByProduct(defaultFilterValue.value as ProductRefType);
  };

  const handleOnFilterProductSelect = (
    e: SelectChangeEvent<string | number | string[]>,
  ): void => {
    setFilterByProduct(e.target.value as ProductRefType);
  };

  return (
    <SectionHalfItemContainer>
      <GridItem size={{ md: 6 }}>
        <div className="scd-filter-spacing">
          <FilterByFamily
            onSelect={handleOnFilterFamilySelect}
            initialValue={filterByFamily}
          />
        </div>
      </GridItem>
      <GridItem size={{ md: 6 }}>
        <div className="scd-filter-spacing">
          <FilterByProduct
            onSelect={handleOnFilterProductSelect}
            initialValue={filterByProduct}
            filterByFamily={filterByFamily}
            defaultFilterValue={defaultFilterValue}
          />
        </div>
      </GridItem>
    </SectionHalfItemContainer>
  );
}
